export function isTelegramWebApp(): boolean {
  // @ts-expect-error: TelegramWebviewProxy is injected by Telegram
  return typeof TelegramWebviewProxy !== 'undefined';
}
